import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { UserSettingsFilter } from '@/composable/useUserSettings'

export function getUserSettings(): Promise<AxiosResponse<UserSettingsFilter>> {
  return instance.get(`/user-setting`)
}
